import { createContext, useEffect, useState } from 'react';
import useTraffic from '../traffic/useTraffic';
import useDomain from '../domains/useDomain';

export const OfferContext = createContext({});

export default function OfferProvider({ children }) {
  const { getTrafficSlim } = useTraffic();
  const { getDomainsSlim } = useDomain();

  const [traffic, setTraffic] = useState([]);
  const [domains, setDomains] = useState([]);
  const [loading, setLoading] = useState(true);

  const init = () => {
    setLoading(true);

    const trafficCall = getTrafficSlim();
    const domainCall = getDomainsSlim();

    (async function () {
      try {
        const [loadedTraffic, loadedDomains] = await Promise.all([
          trafficCall.call(),
          domainCall.call(),
        ]);

        setTraffic(loadedTraffic);
        setDomains(loadedDomains);
      } catch (e) {
      } finally {
        setLoading(false);
      }
    })();

    return () => {
      trafficCall.abort();
      domainCall.abort();
    };

  };

  useEffect(() => {
    return init();
  }, []);

  return (
    <OfferContext.Provider value={{ traffic, loading, domains }}>
      {children}
    </OfferContext.Provider>
  );
}
